import React, { useState, useEffect, useRef } from 'react';
import {
  IconButton,
  IconAdminToolsLine,
  Spinner
} from '@smarterservices/smarter-ui';
import { getStore } from '../../../../stores/StoreContext';
import { ButtonWithConfirmation } from '@ui/shared/components/Common/ButtonWithConfirmation';
const AdjustAnnotationButton = ({
  annotation,
  onDeleted,
  margin = "none none none xx-small"
}) => {

  const [deleteInProgress, setDeleteInProgress] = useState(false);
  const ExamSessionStore = getStore('examSessionStore');
   
    const handleDelete = React.useCallback(async () => {
        setDeleteInProgress(true);
        // Implement delete functionality
        const result = await ExamSessionStore.deleteAnnotation(annotation.sid);
        if(result.success){
            onDeleted(result);
        }
        setDeleteInProgress(false);
    }, [ExamSessionStore, annotation.sid, onDeleted]);

  // TODO: Return null for now, once we fully implement this we will put it back in place. 
  return null;

  return (
    <ButtonWithConfirmation
      onConfirm={handleDelete}
      confirmationText="Delete this item?"
      confirmButtonText="Yes"
      cancelButtonText="No"
      confirmButtonColor="danger"
      color="secondary"
      screenReaderLabel="Delete Item"
    >
    {deleteInProgress ? <Spinner size="x-small" /> : <IconAdminToolsLine />}
  </ButtonWithConfirmation>
  );
};

export default AdjustAnnotationButton;
